var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exp-bg change-page-container",class:_vm.way,on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }